module.exports = __webpack_public_path__ + "img/iot.90a3e831.png";